
import {






getDefaultAddress
} from "@/common/js/api.js";
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VTooltip from 'vux/src/components/v-chart/v-tooltip.vue'
import VLine from 'vux/src/components/v-chart/v-line.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Divider from 'vux/src/components/divider/index.vue'


export default {
components: {
XHeader,
Box,
XButton,
XInput,
Group,
CellBox,
Cell,
Scroller,
Icon,
VChart,
VTooltip,
VLine,
Flexbox,
FlexboxItem,
VScale,
Selector,
Divider
},
methods: {
jumpAction(v) {
this.$router.push({ path: "/"+v });
},
haveNotOpen() {
this.$router.push({ path: "/HaveNotOpen" });
},
getDefaultAddress() {
let self = this;
getDefaultAddress({ data: {} }).then(function(data) {
if (data.Content) {





}
});
},
getActivity(activityId) {
},

createOrder() {

},
onSubmit() {

}
},
data() {
return {
title: "菜鸟驿站回收主页",
activity: {
extInfo: {}
},
entity: {
activityId: "",
qrId: "",
memo: ""
},
loaded: false,
};
},
mounted() {

},created() {

this.getDefaultAddress();
}
};



// WEBPACK FOOTER //
// ./src/components/activity/bird/index.vue